import { Renderer, RenderingContext } from "fmko-ts-grid";
import CertTestAdminApp from "./CertTestAdminApp";
import UseTestGroupWidget from "./UseTestGroupWidget";

export default class UseTestGroupRenderer implements Renderer {

    public render(ctx: RenderingContext, o: Object) {
        let testCase = <string>o;

        let widget = new UseTestGroupWidget(testCase, CertTestAdminApp.certTestPanel.selectedGroups);
        ctx.setWidget(widget);
    }

    public canRender(o: Object): boolean {
        return true;
    }
}
